export default function BackArrow({ color = "black" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.45869 8.00338L12.4442 2.01756C12.6091 1.85314 12.6997 1.6333 12.6997 1.39889C12.6997 1.16436 12.6091 0.94465 12.4442 0.779967L11.9198 0.25574C11.7552 0.0907967 11.5352 0 11.3008 0C11.0664 0 10.8467 0.0907967 10.682 0.25574L3.55527 7.38237C3.38994 7.54758 3.2994 7.76832 3.30005 8.00299C3.2994 8.2387 3.38981 8.45919 3.55527 8.62452L10.6754 15.7443C10.8401 15.9092 11.0598 16 11.2943 16C11.5287 16 11.7484 15.9092 11.9133 15.7443L12.4376 15.22C12.7788 14.8788 12.7788 14.3234 12.4376 13.9823L6.45869 8.00338Z"
        fill={color}
      />
    </svg>
  );
}
